import { Inbox } from "lucide-react";

export function UnassignedToggle({ on, onChange, count, testid }) {
  return (
    <button type="button" onClick={() => onChange(!on)} aria-pressed={on} data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${on ? "border-[hsl(var(--gold))] bg-[hsl(var(--gold))] text-white" : "border-slate-300 bg-white text-slate-700 hover:border-slate-500"}`}>
      <Inbox className="h-4 w-4" /> Not assigned yet{on && count !== undefined ? ` (${count})` : ""}
    </button>
  );
}
